import { registerSW } from "virtual:pwa-register";
import { Result } from "@bidbattles/bloks/lib/result";
import { toast } from "sonner";

let _resolveRegistration: (value: Result<ServiceWorkerRegistration>) => void;
let _rejectRegistration: (error: unknown) => void;
const _swRegistration: Promise<Result<ServiceWorkerRegistration>> = new Promise(
	(resolve, reject) => {
		_resolveRegistration = resolve;
		_rejectRegistration = reject;
	},
);

function setRegistration(registration: ServiceWorkerRegistration) {
	_resolveRegistration(Result.ok(registration));
}

function handleRegistrationError(error: Error) {
	console.warn("[bidbattles:sw] registration failed", error);
	_resolveRegistration(Result.error(new Error("Service worker unavailable")));
}

async function withRegistration<T>(
	fn: (
		registration: ServiceWorkerRegistration,
	) => Result<T> | Promise<Result<T>>,
) {
	const registrationResult = await _swRegistration;
	if (!registrationResult.ok) {
		return registrationResult;
	}

	return await fn(registrationResult.data);
}

function register() {
	const updateSW = registerSW({
		onNeedRefresh() {
			toast.info("A new version of the app is available", {
				duration: Number.POSITIVE_INFINITY,
				action: {
					label: "Reload",
					onClick: () => updateSW(),
				},
			});
		},
		onRegisterError(error) {
			handleRegistrationError(
				error instanceof Error ? error : new Error(String(error)),
			);
		},
		onRegisteredSW(_swScriptUrl, registration) {
			if (!registration) {
				handleRegistrationError(
					new Error("Service worker registered, but registration is missing."),
				);
				return;
			}

			setRegistration(registration);
		},
	});

	return updateSW;
}

export const swInterop = {
	withRegistration,
	register,
};
